<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    top
    elevation="24"
    multi-line
  >
    <div class="text--white">
      <div class="font-weight-bold">
        {{ title }}
      </div>

      <div v-if="text">
        {{ text }}
      </div>
    </div>

    <template v-slot:action="{ attrs }">
        <v-btn
        text
        @click="openUrl"
        v-if="url"
        >Open</v-btn>
      <v-btn
        text
        v-bind="attrs"
        @click="show = false"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import EventBus from '@/core/event-bus'

export default {
  name: 'GlobalSnackbar',

  data() {
    return {
      show: false,
      title: '',
      text: '',
      color: '#00aa00',
      timeout: 6000,
      url: null,
    }
  },

  created() {
    EventBus.$on('show-snackbar', this.showSnackbar)
  },

  beforeDestroy() {
    EventBus.$off('show-snackbar', this.showSnackbar)
  },

  methods: {
    showSnackbar(payload = {}) {
      this.title = payload.title || 'Notification'
      this.text = payload.text || ''
      this.color = payload.color || 'success'
      this.timeout = payload.timeout || 6000
      this.show = true
      this.url = payload.url || null
    },

    openUrl() {
      if (!this.url) {
        return
      }

      this.show = false
      this.$router.push(this.url)
    },
  },
}
</script>
<style>
.text--white{
    color: #fff !important;
}
</style>